import { render, staticRenderFns } from "./tongue.vue?vue&type=template&id=159c2060&"
import script from "./tongue.vue?vue&type=script&lang=ts&"
export * from "./tongue.vue?vue&type=script&lang=ts&"
import style0 from "./tongue.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports